import { render, staticRenderFns } from "./MetricsTab.vue?vue&type=template&id=444d362c&scoped=true&"
import script from "./MetricsTab.vue?vue&type=script&lang=js&"
export * from "./MetricsTab.vue?vue&type=script&lang=js&"
import style0 from "./MetricsTab.vue?vue&type=style&index=0&id=444d362c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444d362c",
  null
  
)

export default component.exports